<script setup lang="ts">
import _service from "@/service";
import { useAccountStore } from "@/stores/account";
import { useSystemStore } from "@/stores/system";
import { $BigNumber, isDev, isInIframe } from "@/utils";
import { getArmadillo, getArmadilloClient } from "@/utils/armadillo";
import { isApp } from "@/utils/device";
import { transact } from "@/utils/transact";
import { closeToast, showLoadingToast, showToast } from "vant";
import { computed, onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
const { t } = useI18n();
const route = useRoute();
const id = route.params.id;
const systemStore = useSystemStore();
const router = useRouter();
const detail = ref<any>(null);
const loading = ref<boolean>(false);
const balance = ref('0');
const accountStore = useAccountStore()
let memberUserInfo = reactive({
  receiverMobile: "",
  receiverName: "",
});
console.log(import.meta.env.MODE);

const getUserBalance = async () => {
  const [_balance]: any = await _service.getBalanceByUser({
    code: "star.token",
    account: accountStore.getUserInfo.name,
    symbol: "STAR",
  });
  balance.value = _balance?.split(' ')[0] || 0;
};

const exchangeFn = async () => {
  if (detail?.value.payIntegral && (+balance.value) < detail?.value.payIntegral / 10000) {
    showToast('兑换积分不足')
    return false
  }
  try {
    console.log(memberUserInfo, "memberUserInfo");
    loading.value = true;
    const postData = {
      items: [
        {
          skuId: detail.value.skus[0].id,
          count: 1,
        },
      ],
      pointStatus: false,
      deliveryType: 3,
      ...memberUserInfo,
      remark: "",
    };
    const {data}: any = await _service.createStarOrder(postData);
    if (!data.payOrderId) {
      return false
    }
    const starData = {
      name: detail.value.name,
      price: detail.value.price,
      initialPrice: detail.value.skus[0].price,
      totalPrice: detail.value.price,
      quantity: detail.value.count || 1,
      payIntegral:detail.value.payIntegral/10000
    };
    const orderData = data
    loading.value = false;
    console.log(starData.initialPrice,'starData.initialPrice');
    if (!starData.initialPrice) {
      actionPay(orderData,starData)
    }else{
      sessionStorage.setItem(
        "ORDER_DATA",
        JSON.stringify({
          starData,
          orderData,
        })
      );
      router.push("/star-pay?integral=true");
    }
  } catch (error) {
    console.log(error);
  }
};


const actionPay = async (orderData:any,starData:any) => {
  try {
    const actions: any = [];
    const hasArmadillo = getArmadillo()
    if (hasArmadillo) {
      //integralActionsPost
      const orderDetail = await _service.getOrderDetail({id:orderData.id})
      const _data = {
        account:import.meta.env.VITE_STAR_CONTRACT,
        name: "transfer",
        data: {
          from:accountStore.getUserInfo.name,
          to:import.meta.env.VITE_APP_PAY,
          quantity:`${$BigNumber(starData.payIntegral).toFixed(4)} STAR`,
          memo: `integral:${orderData.no}:1:1:${orderDetail.data.payExpireTime}`
        },
      };
      actions.push(_data);
      console.log(actions, "actions---");
      const res = await transact(actions);
      showToast('兑换成功')
    }
  } catch (error) {
    console.log(error);
    
  }
}

const getAppUserInfo = async () => {
  try {
    const { data } = await _service.getUserInfo({});
    const { mobile, nickname } = data;
    // appUserInfo.value = {
    //   receiverName:nickname,
    //   receiverMobile:mobile
    // }
    memberUserInfo.receiverMobile = mobile;
    memberUserInfo.receiverName = nickname;
  } catch (error) {
    console.log(error, "getAppUserInfo error");
  }
};

const getDetail = async () => {
  showLoadingToast({
    message: t("Loading"),
    duration: 0,
  });
  const { data } = await _service.getProductDetail({ id, saleLocation: 1 });
  const limitedPurchaseEndTime = Math.max.apply(Math, data.skus.map((o:any)=> {return o.limitedPurchaseEndTime}))
  const limitedPurchaseStartTime = Math.min.apply(Math, data.skus.map((o:any)=> {return o.limitedPurchaseStartTime}))
  console.log(limitedPurchaseStartTime,'limitedPurchaseStartTime');
  console.log(limitedPurchaseEndTime,'limitedPurchaseEndTime');
  detail.value = {...data,limitedPurchaseEndTime,limitedPurchaseStartTime};
  closeToast();
};
const CoinRate = computed(() => {
  return systemStore.globalCurrency.rate || 1;
});
const globalCurrency = computed(() => {
  return systemStore.globalCurrency;
});

onMounted(async() => {
  await getUserBalance()
  getAppUserInfo();
  getDetail();
});
</script>

<template>
  <div class="detail-layout">
    <div
      class="bg"
      :style="`background:url(${detail?.picUrl});background-size: cover;background-repeat: no-repeat;`"
    ></div>
    <div class="layout">
      <div class="header box">
        <div class="price flex-row-between-center">
          <span>
            <span class="number">{{ detail?.payIntegral / 10000 || 0 }}</span>
            STAR
            <span v-if="detail?.price">
              <span class="add">+</span>
              <span class="symbol">{{ globalCurrency.symbol }}</span>
              <span class="number">{{
                Number(
                  $BigNumber(detail?.price).div(100).times(CoinRate).toFixed(2)
                )
              }}</span>
            </span>
          </span>
          <span class="marketprice"
            >{{ globalCurrency.symbol
            }}{{
              Number(
                $BigNumber(detail?.marketPrice)
                  .div(100)
                  .times(CoinRate)
                  .toFixed(2)
              )
            }}</span
          >
        </div>
        <div class="title">{{ detail?.name }}</div>
      </div>
      <div class="info box">
        <div class="title">{{t('Basic information')}}</div>
        <div
          class="row"
          v-for="item in detail?.skus[0].properties"
          :key="item.id"
        >
          <span class="name">{{ item.propertyName }}</span>
          <span class="ct">{{ item.valueName }}</span>
        </div>
      </div>
      <div class="detail box">
        <div class="title">{{t('Product Details')}}</div>
        <div class="detailct" v-html="detail?.description"></div>
      </div>
    </div>
    <div class="footer">
      <div class="btn"  :class="{'count-time':detail?.limitedPurchaseStartTime > new Date().getTime(),'disabled':detail?.limitedPurchaseStartTime > new Date().getTime() || detail?.limitedPurchaseEndTime < new Date().getTime()}" @click="exchangeFn()">
        {{t('Redeem now')}}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 375px;
  background-size: contain;
  background-repeat: no-repeat;
  // background-attachment: fixed;
  img {
    width: 100%;
    height: 375px;
    border: none;
    object-fit: cover;
    font-size: 0;
    outline: none;
  }
}
.detail-layout {
  height: 100%;
  min-height: 100vh;
  background: #070b14;
}
.layout {
  padding: 0 16px;
  display: flex;
  margin-top: -50px;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 90px;
  .box {
    display: flex;
    width: 100%;
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    border-radius: 12px;
    background: #1f212d;
  }
  .header {
    color: #6efa97;
    font-family: "D-DIN Exp";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 100% */
    .price {
      width: 100%;
      color: #6efa97;
      font-family: "D-DIN Exp";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
      .number {
        color: #6efa97;
        font-family: "D-DIN Exp";
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 100% */
      }
      .marketprice {
        color: $text2;
        font-family: Poppins;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 140% */
        text-decoration: line-through;
      }
    }

    .title {
      width: 100%;
      overflow: hidden;
      color: $text1;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 128.571% */
      text-transform: capitalize;
    }
  }
  .info {
    .title {
      color: $text1;
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    .row {
      display: flex;
      align-items: center;
      gap: 12px;
      .name {
        color: $text2;
        font-family: "Noto Sans SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .ct {
        color: $text1;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px; /* 150% */
        text-transform: capitalize;
      }
    }
  }
  .detail {
    .title {
      color: $text1;
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    .detailct {
      white-space: pre-line;
      line-height: 1.4;
      font-size: 14px;
      color: #fff;
      :deep(img) {
        width: 100%;
      }
    }
  }
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  background: #070b14;
  .btn {
    width: 100%;
    display: flex;
    padding: 12px 10px;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    background: linear-gradient(
      111deg,
      #fff853 4.98%,
      #6eef94 56.05%,
      #2ad8cd 95.37%
    );
    color: #070b14;
    text-align: center;
    font-family: "Noto Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    &.disabled{
      opacity:0.3;
      pointer-events: none;
    }
  }
}
</style>
